import { TFunction } from 'i18next'
import {
  getUserConfigFromUserFacingRole,
  getUserFacingRoleFromUserConfig,
  isUserFacingRole,
  UserFacingRole,
  type UserRoleConfig,
} from '@omnea-app/packages/universal/roles/userFacingRoles'
import { assertNever } from '@omnea-app/packages/universal/type-guards/assertNever'

export { getUserConfigFromUserFacingRole, getUserFacingRoleFromUserConfig, isUserFacingRole, UserFacingRole, type UserRoleConfig }

export const getUserFacingRoleLabel = ({
  t,
  role,
  p2pAdminMode = false,
}: {
  t: TFunction<'settings'>
  role: UserFacingRole
  /** P2P_ADMIN_MODE (frontend-only HubSpot stop-gap): renders the Admin role as "P2P User". */
  p2pAdminMode?: boolean
}): string => {
  switch (role) {
    case UserFacingRole.SUPER_ADMIN:
      return t('users.role-super-admin')
    case UserFacingRole.ADMIN:
      return p2pAdminMode ? t('users.role-p2p-user') : t('users.role-admin')
    case UserFacingRole.VIEWER:
      return t('users.role-viewer')
    case UserFacingRole.USER:
      return t('users.role-user')
    case UserFacingRole.SUPPLIER:
      return t('users.role-supplier')
    default:
      assertNever(role)
      return t('role-label.unknown')
  }
}

export const getRoleLabelFromUserConfig = ({
  t,
  userConfig,
  p2pAdminMode = false,
}: {
  t: TFunction<'settings'>
  userConfig: UserRoleConfig
  p2pAdminMode?: boolean
}) => getUserFacingRoleLabel({ t, role: getUserFacingRoleFromUserConfig(userConfig), p2pAdminMode })
